import { render, staticRenderFns } from "./TheNegotiationsFormButtons.vue?vue&type=template&id=18ed8ad0&"
import script from "./TheNegotiationsFormButtons.vue?vue&type=script&lang=js&"
export * from "./TheNegotiationsFormButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports